import { render, staticRenderFns } from "./JudgeTable.vue?vue&type=template&id=f5ceec42&scoped=true"
import script from "./JudgeTable.vue?vue&type=script&lang=js"
export * from "./JudgeTable.vue?vue&type=script&lang=js"
import style0 from "./JudgeTable.vue?vue&type=style&index=0&id=f5ceec42&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5ceec42",
  null
  
)

export default component.exports